import { DEFAULT_LOCALE, SUPPORTED_LOCALES } from '@repo/web-chrome/i18n';
import { defineRouting } from 'next-intl/routing';

export const routing = defineRouting({
  locales: SUPPORTED_LOCALES,
  defaultLocale: DEFAULT_LOCALE,
  localePrefix: 'as-needed',
  localeCookie: false,
  localeDetection: false,
});
